export enum CourseType {
    unknown = -1,
    course = 0,
    trainingLibrary = 1,
    referenceLibrary = 2,
    archive = 3
}